import * as React from 'react'
import { Button } from 'react-bootstrap'
import { exportToCsvList } from '../../Helpers/ExportCsvHelper'
import { inject, observer } from 'mobx-react'
import ExportStore, { ExportType } from '../../Stores/ExportStore'
import LocalizationStore from '../../Stores/LocalizationStore'

export interface IExportToCsvComponentProps {
    exportStore?: ExportStore,
    exportType: ExportType,
    localizationStore?: LocalizationStore
}

@inject('exportStore')
@inject('localizationStore')
@observer
export default class ExportToCsvComponent extends React.Component<IExportToCsvComponentProps> {
    render() {
        const { exportStore, exportType, localizationStore } = this.props
        let data = exportStore!.getItems

        if (!data || !data[exportType.toString()] || !data[exportType.toString()].length) {
            return (
                <div className="p-2">
                    {localizationStore!.t('no data to export')}
                </div>
            )
        }

        return (
            <Button
                className="p-2"
                onClick={() => {
                    exportToCsvList(`${ExportType[exportType]}.csv`, data![exportType.toString()])
                    return
                }}
            >
                to csv
            </Button>
        )
    }
} 


// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/Components/ExportToCsvComponent/index.tsx